import { render, staticRenderFns } from "./DefaultPageComponent.vue?vue&type=template&id=02256673&scoped=true"
import script from "./DefaultPageComponent.vue?vue&type=script&lang=js"
export * from "./DefaultPageComponent.vue?vue&type=script&lang=js"
import style0 from "./DefaultPageComponent.vue?vue&type=style&index=0&id=02256673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02256673",
  null
  
)

export default component.exports